import React from 'react';

import { Popover as PopoverCore, PopoverProps as IPopoverProps } from 'antd';

const Popover = (props: IPopoverProps) => {
	const {
		children,
		trigger = 'click',
		placement = 'bottomRight',
		autoAdjustOverflow = true,
		...restProps
	} = props;

	return (
		<PopoverCore
			autoAdjustOverflow={autoAdjustOverflow}
			destroyTooltipOnHide
			getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
			trigger={trigger}
			placement={placement}
			{...restProps}
		>
			{children}
		</PopoverCore>
	);
};

export default Popover;
